import React from 'react'; // TODO

var FormContext = /*#__PURE__*/React.createContext({
  controlId: undefined
});
export default FormContext;